import { User } from "../../types/users";
import { getUserState } from "../../store";
import { setAccessToken } from "../../store/accessToken";
import { waitForCurrentUser } from "./waitForCurrentUser";

export function getMe(accessToken): Promise<User> {
  setAccessToken(accessToken);
  return handleGetMeInvocation();
}

function handleGetMeInvocation(): Promise<User> {
  if (getUserState().dataStatus == "completed") {
    return Promise.resolve(getUserState().data);
  }
  return waitForCurrentUser();
}
